// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-fa687c00]{position:relative;z-index:11;display:flex;align-items:center;color:#51596c}button .icon[data-v-fa687c00]{margin-left:.625rem;margin-top:-.3125rem}", ""]);
// Exports
module.exports = exports;
